import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="faq-title" data-id="element-172" data-mp="122dcx9d3pxct">
      <div className="mx-auto max-w-3xl" data-id="element-173" data-mp="1psh94vnymuts">
        <div id="faq-title" data-id="element-174" data-mp="1psprh32uqscd">
          <SectionHeading eyebrow="Frequently asked questions" title="Everything you may be wondering" data-id="element-175" data-mp="1puk1vnghz227" />
        </div>

        <ul className="mt-9 space-y-3" data-id="element-176" data-mp="1g2nzw1bairsp">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-177" data-mp="1kzwl6arqjby6" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-sand" data-id="element-178" data-mp="28pilj1jufx7r">
                  <span className="text-[15px] font-bold leading-snug text-navy sm:text-[16.5px]" data-id="element-179" data-mp="2jpb3frusml18">
                    {faq.q}
                  </span>
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose-mist text-rose" aria-hidden="true" data-id="element-180" data-mp="2tojti9mjffib">
                    {isOpen ? <MinusIcon className="h-3.5 w-3.5" data-id="element-181" data-mp="32hdnzeak2lgr" /> : <PlusIcon className="h-3.5 w-3.5" data-id="element-182" data-mp="3hemiuhz2i7d8" />}
                  </span>
                </button>
                {isOpen ? <p className="border-t border-navy/10 px-5 py-4 text-[14.5px] leading-relaxed text-navy/70 sm:text-[15.5px]" data-id="element-183" data-mp="3cgusvthzgvbo">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-184" data-mp="27pxn75i3vfsc">
          <CtaButton label="Got it — I want access" subtext="One-time $27 · Instant access · 7-day guarantee" data-id="element-185" data-mp="27r8zjtpm9vv2" />
        </div>
      </div>
    </section>;
}